import { ApiObservationFrequency, ApiStrategyTemplate } from 'api/rtk-api'

import { EditStrategiesActions } from '../../../../modules/strategy-admin/state/edit-strategy-slice'
import { Errors } from '../../../../modules/tradebuilder-v2/util'
import { Attribute, FormItem, Label, NumberInput, Select, ValidationMessage } from '../..'

type ProtectionParameterInputProps = {
  actions: EditStrategiesActions
  errors: Errors
  strat: ApiStrategyTemplate
}

function round(val: number, pow: number) {
  const exp = 10 ** pow
  const res = Math.round(val * exp) / exp
  return res
}

export function ProtectionParameterInput({
  actions,
  errors,
  strat
}: ProtectionParameterInputProps) {
  return (
    <>
      <FormItem>
        <Label>Protection level</Label>
        <Attribute nameComponent="Minimum (%)">
          <NumberInput
            value={strat.minProtectionLevel === 0 ? '' : round(strat.minProtectionLevel * 100, 2)}
            onChange={v => actions.setMinProtectionLevel(round(Number(v.target.value) / 100, 4))}
          />
        </Attribute>
        <Attribute nameComponent="Default (%)">
          <NumberInput
            value={
              strat.defaultProtectionLevel === 0 ? '' : round(strat.defaultProtectionLevel * 100, 2)
            }
            onChange={v =>
              actions.setDefaultProtectionLevel(round(Number(v.target.value) / 100, 4))
            }
          />
        </Attribute>
        <Attribute nameComponent="Maximum (%)">
          <NumberInput
            value={strat.maxProtectionLevel === 0 ? '' : round(strat.maxProtectionLevel * 100, 2)}
            onChange={v => actions.setMaxProtectionLevel(round(Number(v.target.value) / 100, 4))}
          />
        </Attribute>
        <ValidationMessage errors={errors} fieldName="prot_levels" />
        <ValidationMessage errors={errors} fieldName="max_cts_prot_level" />
        <ValidationMessage errors={errors} fieldName="max_term_prot_level" />
      </FormItem>
      <FormItem>
        <Label>HWM frequency</Label>
        <Attribute nameComponent="Frequency">
          <Select
            value={strat.defaultHighWatermarkObservationFrequency}
            onChange={v => actions.setDefaultHWMFreq(v.target.value as ApiObservationFrequency)}
          >
            <option value="None">None</option>
            <option value="Daily">Daily</option>
            <option value="Weekly">Weekly</option>
            <option value="Monthly">Monthly</option>
            <option value="Quarterly">Quarterly</option>
            <option value="SemiAnnually">Semi annually</option>
            <option value="Annually">Annually</option>
          </Select>
        </Attribute>
      </FormItem>
      {strat.strategyType === 'CPPI' && (
        <FormItem>
          <Label>Number of months to maturity</Label>
          <Attribute nameComponent="Minimum">
            <NumberInput
              value={
                strat.minNumberOfMonthsToTimeToMaturity === 0
                  ? ''
                  : strat.minNumberOfMonthsToTimeToMaturity
              }
              onChange={v => actions.setMinNumMonthsToMaturity(Number(v.target.value))}
            />
          </Attribute>
          <Attribute nameComponent="Maximum">
            <NumberInput
              value={
                strat.maxNumberOfMonthsToTimeToMaturity === 0
                  ? ''
                  : strat.maxNumberOfMonthsToTimeToMaturity
              }
              onChange={v => actions.setMaxNumMonthsToMaturity(Number(v.target.value))}
            />
          </Attribute>
          <ValidationMessage errors={errors} fieldName="maturity_months" />
          <ValidationMessage errors={errors} fieldName="min_maturity_month" />
          <ValidationMessage errors={errors} fieldName="max_maturity_month" />
        </FormItem>
      )}
    </>
  )
}
